module.exports = __webpack_public_path__ + "img/moustache-pink.5c5f4a1f.svg";